import { application } from "./application"
import EmojiController from "./emoji_controller"
import EmojiBlastController from "./emoji_blast_controller"
import ClipboardController from "./clipboard_controller"
import IntakeQuestionsSortableController from "./intake_questions_sortable_controller"
import ToggleController from "./toggle_controller"
import CategorySubcategoryController from "./category_subcategory_controller"
import SongPromptEditorController from "./song_prompt_editor_controller"
import OtherInputController from "./other_input_controller"
import FlashController from "./flash_controller"
import StudioComposerController from "./studio_composer_controller"

application.register("emoji", EmojiController)
application.register("emoji-blast", EmojiBlastController)
application.register("clipboard", ClipboardController)
application.register("intake-questions-sortable", IntakeQuestionsSortableController)
application.register("toggle", ToggleController)
application.register("category-subcategory", CategorySubcategoryController)
application.register("song-prompt-editor", SongPromptEditorController)
application.register("other-input", OtherInputController)
application.register("flash", FlashController)
application.register("studio-composer", StudioComposerController)

import StudioPollController from "./studio_poll_controller"
application.register("studio-poll", StudioPollController)
